module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('date-picker', {
    attrs: {
      "width": "100%",
      "lang": "en"
    },
    on: {
      "input": function($event) {
        _vm.input($event)
      }
    },
    model: {
      value: (_vm.valueDate),
      callback: function($$v) {
        _vm.valueDate = $$v
      },
      expression: "valueDate"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-190f6726","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DateField.vue
// module id = 273
// module chunks = 0